module.exports = fox._r("fonts/museosanscyrl_2-webfont.ttf", __webpack_public_path__ + "fonts/1pjWp8c.ttf");


//////////////////
// WEBPACK FOOTER
// ./fonts/museosanscyrl_2-webfont.ttf
// module id = 569
// module chunks = 2